import { createBrowserRouter, Navigate } from "react-router-dom";
import AuthenticatedApp from "../pages/AuthenticatedApp";
import UnauthenticatedApp from "../pages/UnauthenticatedApp";
import {
  LoginPage,
  SignupPage,
  ForgotPasswordPage,
  ResetPasswordPage,
  FeedbackFromEmailsPage,
  CrewUpdatePage,
} from "../pages/auth";
import { operatorRoutes } from "./operatorRoutes";
import { managerRoutes } from "./managerRoutes";
import { adminRoutes } from "./adminRoutes";
import { authLoader, dcLoader } from "../loaders/index";
import App from "../App";
import RouteError from "@src/components/utility/RouteError";
import { UsernameTypes } from "@src/constants/constants";

export const roleRoutes = {
  CAPTAIN: operatorRoutes,
  FUEL_MANAGER: managerRoutes,
  ADMINISTRATOR: adminRoutes,
};

export const appRoutes = () => {
  return createBrowserRouter([
    /* Routes outside of the main app layout can be added here, for example: */
    {
      path: "feedbackFromEmails",
      element: <FeedbackFromEmailsPage />,
    },
    /* Main app layout with nested routes */
    {
      path: "/",
      loader: async (req) => ({
        authSession: authLoader(req),
      }),
      element: <App />,
      errorElement: <RouteError />, // ErrorBoundary for route-level errors
      children: [
        {
          // private routes
          path: "dashboard",
          element: <AuthenticatedApp />,
          children: [...Object.values(roleRoutes).flat()],
          loader: async (req) => ({
            dynamicContent: dcLoader(req),
          }),
        },
        {
          // public routes
          element: <UnauthenticatedApp />,
          children: [
            {
              index: true,
              element: <LoginPage usernameType={UsernameTypes.GUEST} />,
            },
            {
              path: "login",
              element: <LoginPage usernameType={UsernameTypes.GUEST} />,
            },
            {
              path: "*",
              element: <Navigate to="/" replace />,
            },
            {
              path: "loginEmail", // aviation
              element: <LoginPage usernameType={UsernameTypes.EMAIL_ADDRESS} />,
            },
            {
              path: "loginUsername", // maritime
              element: <LoginPage usernameType={UsernameTypes.USERNAME} />,
            },
            {
              path: "signup",
              element: <SignupPage />,
            },
            {
              path: "crewUpdate",
              element: <CrewUpdatePage />,
            },
            {
              path: "forgotPassword",
              element: <ForgotPasswordPage />,
            },
            {
              path: "resetPassword",
              element: <ResetPasswordPage />,
            },
            // resetPassword
            // validateAccount
            // etc...
          ],
        },
      ],
    },
  ]);
};
